import Cascader from './src/cascader'
import CascaderPanel from './src/cascaderPanel'

Cascader.panel = CascaderPanel

export default Cascader
